import { render, staticRenderFns } from "./ResumoAlertasJusBr.vue?vue&type=template&id=6f983d48&scoped=true&"
import script from "./ResumoAlertasJusBr.vue?vue&type=script&lang=js&"
export * from "./ResumoAlertasJusBr.vue?vue&type=script&lang=js&"
import style0 from "./ResumoAlertasJusBr.vue?vue&type=style&index=0&id=6f983d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f983d48",
  null
  
)

export default component.exports